module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Langenbruck-547367dc8db870e4f0767c52e312afc5.png";